import { render, staticRenderFns } from "./nxHeadDownload.vue?vue&type=template&id=3c55443c&scoped=true&"
import script from "./nxHeadDownload.vue?vue&type=script&lang=js&"
export * from "./nxHeadDownload.vue?vue&type=script&lang=js&"
import style0 from "./nxHeadDownload.vue?vue&type=style&index=0&id=3c55443c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c55443c",
  null
  
)

export default component.exports